import { render, staticRenderFns } from "./KiddLinks.vue?vue&type=template&id=9892db50&scoped=true&lang=pug"
import script from "./KiddLinks.vue?vue&type=script&lang=js"
export * from "./KiddLinks.vue?vue&type=script&lang=js"
import style0 from "./KiddLinks.vue?vue&type=style&index=0&id=9892db50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9892db50",
  null
  
)

export default component.exports